module.exports = __webpack_public_path__ + "img/ИФ-1(А)-013-m.74fa1a7f.png";